export default "__VITE_ASSET__c0b77b8e__"